'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setSettingPage = setSettingPage;
exports.loadPageDetail = loadPageDetail;

var _constants = require('redux/constants');

function setSettingPage() {
    var pageList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return {
        type: _constants.PageConstants.SET_PAGE_LIST,
        result: pageList
    };
}

function loadPageDetail(id, shopId) {
    return {
        types: [_constants.PageConstants.PAGE_DETAIL_LOAD_REQUEST, _constants.PageConstants.PAGE_DETAIL_LOAD_SUCCES, _constants.PageConstants.PAGE_DETAIL_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getPageDetail(id, shopId);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/page.js
// module id = 766
// module chunks = 0